import { UUID } from "crypto";
import { Position, IPiece, ISideEffect, Effect } from "./types";

export class SideEffect implements ISideEffect {
  id: UUID;
  moveId: UUID;
  position: Position;
  piecesToEffect: IPiece[];
  effect: Effect;

  constructor(
    moveId: UUID,
    position: Position,
    pieces: IPiece[],
    effect: Effect
  ) {
    this.id = crypto.randomUUID() as UUID;
    this.moveId = moveId;
    this.position = position;
    this.piecesToEffect = pieces;
    this.effect = effect;
  }
}
